/**
 * Exit / Risk System
 *
 * Two-layer exit logic:
 * - EXIT WARNING (FAST): institutional net negative, sellerRatio > 1.2, acceleration sharply negative, retail dominates
 * - DISTRIBUTION CONFIRMED: institutional net negative 2 consecutive days + sellerRatio > 1 + acceleration negative
 * - FORCED EXIT: handled by real trades module (stop hit)
 *
 * Behavior rules:
 * - If user OWNS stock: apply exit guidance
 * - If user DOES NOT own: if exitMode = CONFIRMED → block new entries
 */
export function computeExitModel(features, owned) {
  const daily = features.dailyData || [];
  if (!daily.length) return { exitMode: 'NONE', entryAllowed: true };

  const latest = daily[daily.length - 1];
  const last2 = daily.slice(-2);
  let exitMode = 'NONE';

  // EXIT WARNING (FAST) — trigger if ANY condition met
  const hasWarning =
    latest.instNet < 0 ||
    latest.sellerRatio > 1.2 ||
    latest.accelerationScore < -0.5 ||
    (latest.retailNet > 0 && latest.instNet < latest.retailNet * 0.5);

  if (hasWarning) exitMode = 'WARNING';

  // DISTRIBUTION CONFIRMED — stricter conditions
  if (last2.length >= 2) {
    const bothInstNegative = last2.every(d => d.instNet < 0);
    const sellerHigh = latest.sellerRatio > 1;
    const accelNegative = latest.accelerationScore < 0;

    if (bothInstNegative && sellerHigh && accelNegative) {
      exitMode = 'CONFIRMED';
    }
  }

  // Entry allowed logic
  let entryAllowed = true;
  if (!owned && exitMode === 'CONFIRMED') {
    entryAllowed = false;
  }

  return { exitMode, entryAllowed };
}
